// GET_SEASONALITY_SCHEMAS

import {
  GET_SEASONALITY_SCHEMAS,
  UPDATE_SEASONALITY_SCHEMAS
} from "./../actions/types";

const INITIAL_STATE = {
  seasonalitySchemas: {}
};

export default function(state = {}, action) {
  switch (action.type) {
    case GET_SEASONALITY_SCHEMAS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/seasonalitySchemas.js